import { VueConstructor } from 'vue/types/umd';
import ManitobaV1Form from './ManitobaV1Form.vue';
import ManitobaV1Table from './ManitobaV1Table.vue';
import OntarioIDv1Form from './OntarioIDv1Form.vue';
import OntarioIDv1Table from './OntarioIDv1Table.vue';
import SimpleV1Form from './SimpleV1Form.vue';
import SimpleV1Table from './SimpleV1Table.vue';

const types: {
  [key: string]: {
    form: VueConstructor;
    table: VueConstructor;
  };
} = {
  Manitoba_v1: {
    form: ManitobaV1Form,
    table: ManitobaV1Table,
  },
  OntarioID_v1: {
    form: OntarioIDv1Form,
    table: OntarioIDv1Table,
  },
  Simple_v1: {
    form: SimpleV1Form,
    table: SimpleV1Table,
  },
};

// helper function to generate an object that can be used to load the components easily
const getComponents = (): any => {
  const components: any = {};
  Object.entries(types).forEach((entry) => {
    components[`${entry[0]}_FORM`] = entry[1].form;
    components[`${entry[0]}_TABLE`] = entry[1].table;
  });
  return components;
};

export default {
  ...types,
};

export { getComponents };
